import countryEn from "./countries-en.json";
import countryIt from "./countries-it.json";
import italyRegionAndProvicne from "./italy-region-and-provinces.json";

const countries = {
  it: countryIt,
  en: countryEn,
  el: countryEn,
};

jQuery(document).ready(function ($) {
  var countrySelect = $(".ortica-country select");
  var regionSelect = $(".ortica-region select");
  var provinceSelect = $(".ortica-province select");

  countrySelect.find("option").not(":first").remove();
  countrySelect.append(
    $(
      `${countries[ortica.lang]
        .map(
          (country) =>
            `<option value="${country.name}">${country.name}</option>`
        )
        .join("")}`
    )
  );

  if (ortica.lang !== "it") return;

  countrySelect.on("change", function () {
    regionSelect.find("option").not(":first").remove();

    if (countrySelect.val() !== "Italia") {
      // reset to first disable value
      regionSelect.val(regionSelect.find("option:first").val());
      provinceSelect.val(countrySelect.find("option:first").val());

      provinceSelect.find("option").not(":first").remove();
      return;
    }

    regionSelect = $(".ortica-region select");
    provinceSelect = $(".ortica-province select");

    if (regionSelect.length && provinceSelect.length) return;

    setTimeout(() => {
      regionSelect = $(".ortica-region select");
      provinceSelect = $(".ortica-province select");

      regionSelect.val(regionSelect.find("option:first").val());
      provinceSelect.val(countrySelect.find("option:first").val());

      regionSelect.append(
        $(
          `${italyRegionAndProvicne
            .map(
              (region) =>
                `<option value="${region.name}">${region.name}</option>`
            )
            .join("")}`
        )
      );

      regionSelect.on("change", function () {
        provinceSelect.find("option").not(":first").remove();
        provinceSelect.val(provinceSelect.find("option:first").val());

        const selectedRegion = italyRegionAndProvicne.find(
          (region) => region.name === regionSelect.val()
        );

        provinceSelect.append(
          $(
            `${selectedRegion.provinces
              .map(
                (province) =>
                  `<option value="${province.name}">${province.name}</option>`
              )
              .join("")}`
          )
        );
      });
    }, 500);
  });
});
